import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import { 
    FormGroup,
	Label,
 } from 'Actions';

 // app config
import AppConfig from 'Constants/AppConfig';
 // rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

class ViewItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {

	}

    constructor(props) {
      
        super(props);
        this.nodeRef = React.createRef();
        this.state = {  
            seldate:'', 
            student:'', 
            heightProportion: 1600,
            widthProportion: 500
        };
    }


render() {

    const { particularsamlabreport, loading} = this.props; 
    const allfile=particularsamlabreport.tsr_filename;
    if(allfile==''){
        var exfiles=[];
        var filecnt=0;
    }else{
        var exfiles=allfile.split(',');
        var filecnt=exfiles.length;
    }

    const styles = {
        subheading: {
            fontWeight:"bold"
        }

    }    
      return(
            <div>
                <div className="col-md-12">
                <div className="row">
                        <div className="col-sm-12 col-md-4">
                            <RctCollapsibleCard heading="SAM LAB DETAILS">
                                <div className="float-right">
                                    <button type="button" className="mr-10 mb-10 btn btn-outline-warning " onClick={this.props.onClick}>Back</button> 
                                </div> 
                                <div className="table-responsive">
                                    <Table hover bordered striped>
                                        
                                        <tbody>                              
                                        
                                            <tr>
                                                <td>STUDENT</td>
                                                <td style={styles.subheading}> {particularsamlabreport.student} </td>
                                            </tr>
                                            <tr>
                                                <td>DATE</td>
                                                <td style={styles.subheading}> {particularsamlabreport.cdate} </td>
                                            </tr>
                                            <tr>
                                                <td>SETUP</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_setup==0 ? "" :  particularsamlabreport.tsr_setup} </td>
                                            </tr>
                                            <tr>
                                                <td>AIM PERCEPTION</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_aimperception==0 ? "" :  particularsamlabreport.tsr_aimperception} </td>
                                            </tr>
                                            <tr>
                                                <td>AIM</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_aim==0 ? "" :  particularsamlabreport.tsr_aim} </td>
                                            </tr>
                                            <tr>
                                                <td>FACE AT IMPACT</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_faceimpact==0 ? "" :  particularsamlabreport.tsr_faceimpact} </td>
                                            </tr>
                                            <tr>
                                                <td>PATH</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_path==0 ? "" :  particularsamlabreport.tsr_path} </td>
                                            </tr>
                                            <tr>
                                                <td>CONTACT</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_contact==0 ? "" :  particularsamlabreport.tsr_contact} </td>
                                            </tr>
                                            <tr>
                                                <td>LAUNCH</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_launch==0 ? "" :  particularsamlabreport.tsr_launch} </td>
                                            </tr>
                                            <tr>
                                                <td>ACCELERATION PROFILE</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_acceleration==0 ? "" :  particularsamlabreport.tsr_acceleration} </td>
                                            </tr>
                                            <tr>
                                                <td>DRILLS</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_drills==0 ? "" :  particularsamlabreport.tsr_drills} </td>
                                            </tr>
                                            <tr>
                                                <td>REPORT NAME</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_reportname==0 ? "" :  particularsamlabreport.tsr_reportname} </td>
                                            </tr>

                                                                
                                        </tbody>
                                    </Table>
                                </div>   
                            </RctCollapsibleCard>
                        </div> 
                         <div className="col-sm-12 col-md-8" ref={this.nodeRef}>
                            <CarouselProvider                            
                                naturalSlideWidth={this.state.widthProportion}
                                naturalSlideHeight={this.state.heightProportion}
                                totalSlides={filecnt}
                            >
                            <div className="sdfsdf">
                                <div className="text-center" style={{marginTop:"-30px"}}>
                                    {exfiles.map((uptval,idx) => ( 
                                        <Dot className="text-center" slide={idx} >{idx+1}</Dot>
                                    ))}
                                </div>                        
                            </div>
                            <Slider>
                            {exfiles.map((uptval,idx) => (                                  
                                    <Slide index={idx}> 
                                      <RctCollapsibleCard>
                                        <iframe src={AppConfig.apiurl+'/theme/img/samlab/'+uptval} width="100%" height={600} ></iframe> 
                                      </RctCollapsibleCard>
                                    </Slide>
                            ))}        
                            </Slider>
                            </CarouselProvider>    
                         </div>


                        </div>
                </div>
            </div>
              
    )
   
}
 
}

const mapStateToProps = ({ samlabreport}) => {
    const { particularsamlabreport, loading } = samlabreport;
	return { particularsamlabreport, loading };
   
}


export default connect(mapStateToProps, {
    
  
})(ViewItems);
